import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { getLocationUrl } from '@slardar/sdk-web';
export var addEnvToSendEvent = function (ev) {
    var extra = {
        url: getLocationUrl(),
        timestamp: Date.now(),
    };
    return __assign(__assign({}, ev), { extra: __assign(__assign({}, extra), (ev.extra || {})) });
};
export var InjectEnvPlugin = function (client) {
    client.on('report', function (ev) {
        return addEnvToSendEvent(ev);
    });
};
//# sourceMappingURL=inject-env.js.map